import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import reachLogo from '../assets/reach-logo-black-text.svg';
import type { Partner } from '../lib/api';
import { OrgSwitcher } from './OrgSwitcher';
import { useAllFlags } from '../hooks/useAllFlags';
import { SIDEBAR_SECTIONS } from './sidebar-items';
import { SidebarNavSection } from './SidebarNavSection';
import { SidebarAccountMenu } from './SidebarAccountMenu';
import styles from './Sidebar.module.css';

interface SidebarProps {
  activeItem: string;
  partner?: Partner;
}

export const Sidebar = ({ activeItem, partner }: SidebarProps) => {
  const [collapsed, setCollapsed] = useState(
    () => window.matchMedia?.('(max-width: 767px)').matches ?? false,
  );
  const { ld } = useAllFlags();
  const sections = SIDEBAR_SECTIONS.map(section => ({
    ...section,
    items: section.items.filter(item => !item.requiresFlag || ld[item.requiresFlag]),
  }));
  const toggleLabel = collapsed ? 'Expand sidebar' : 'Collapse sidebar';
  return (
    <aside className={styles.sidebar} data-collapsed={collapsed} aria-label="Dashboard navigation">
      <div className={styles.brand}>
        <Link to="/dashboard/metrics" aria-label="Reach overview">
          <img src={reachLogo} alt="Reach" />
        </Link>
        <button
          type="button"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={toggleLabel}
          title={toggleLabel}
          aria-expanded={!collapsed}>
          {collapsed ? <PanelLeftOpen /> : <PanelLeftClose />}
        </button>
      </div>
      {partner && (
        <div className={styles.partnerContext}>
          <OrgSwitcher partner={partner} compact={collapsed} />
        </div>
      )}
      <nav className={styles.navigation} aria-label="Main navigation">
        {sections.map(section => (
          <SidebarNavSection key={section.id} section={section} activeItem={activeItem} />
        ))}
      </nav>
      <SidebarAccountMenu />
    </aside>
  );
};
